import { render, staticRenderFns } from "./addOwnerCommitteeList.vue?vue&type=template&id=d642c970&scoped=true"
import script from "./addOwnerCommitteeList.vue?vue&type=script&lang=js"
export * from "./addOwnerCommitteeList.vue?vue&type=script&lang=js"
import style0 from "./addOwnerCommitteeList.vue?vue&type=style&index=0&id=d642c970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d642c970",
  null
  
)

export default component.exports